import { Tick02Icon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Check = /* @__PURE__ */ createIcon(Tick02Icon, 'Check');
